import React, { useState } from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import styled, { css } from 'styled-components';
import { FlexBox } from '@quikr/ui';
import SeoTags from '@quikr/ui/src/common/SeoTag';
import CategoryList from './categoryList';

const TopBar = loadable(() => import('../TopBar'));
const SubcatSelection = loadable(() => import('@quikr/ui/src/postad/PostAdSelection/SubcatSelection'));
const SubCategoryList = loadable(() => import('@quikr/ui/src/postad/PostAdSelection/subcatList'));

const FlexRow = styled(FlexBox.Row)`
  border-top: 1px solid ${({ theme }) => theme.colors.Neutral[100]};
`;

const Sticky = styled.div`
  ${({ isMobile }) =>
    !isMobile &&
    css`
      position: sticky;
      top: 93px;
      z-index: 1;
    `};
`;

const FlexColumn = styled(FlexBox.Column)`
  @media screen and (min-width: 768px) {
    height: 650px;
  }
`;

const SelectionPage = props => {
  const { categories, isMobile, selectedIndex = 0, openModal = false } = props;
  const [activeIndex, setActiveIndex] = useState(selectedIndex);
  const [parentArray, setParentArray] = useState([]);
  const [openSubcat, setOpenSubcat] = useState(openModal);

  const handleSearch = keyword => {
    const result = parentArray
      .filter(each => each.name.toLowerCase().indexOf(keyword.toLowerCase()) > -1)
      .slice(0, 8);
    return result;
  };

  return (
    <>
      <SeoTags
        meta={{
          title: 'Post free ads in Bangalore , Advertise free online',
          description:
            'Post Free Ads - Classifieds in Bangalore - No registration required. Post your Item and get buyers online',
          keywords: 'post classifieds ads, post items for free, advertise online'
        }}
      />
      {!isMobile && <TopBar handleSearch={handleSearch} />}
      <FlexRow>
        <FlexBox.Column md={5} sm={5} gutterWidth={0}>
          <Sticky isMobile={isMobile}>
            {
              <CategoryList
                isMobile={isMobile}
                setActiveIndex={setActiveIndex}
                activeIndex={activeIndex}
                categories={categories}
                handleOnClick={setOpenSubcat}
              />
            }
            { (
              <SubcatSelection
                openSubcat={openSubcat}
                isMobile={isMobile}
                categories={categories}
                activeIndex={activeIndex}
                parentArray={parentArray}
                setParentArray={setParentArray}
                handleBack={() => setOpenSubcat(false)}
              />
            )}
          </Sticky>
        </FlexBox.Column>
        {!isMobile && (
          <FlexColumn md={7} sm={7} xs={12} gutterWidth={20} className="oyA">
            <SubCategoryList categories={categories} activeIndex={activeIndex} />
          </FlexColumn>
        )}
      </FlexRow>
    </>
  );
};

SelectionPage.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      category: PropTypes.object,
      subdata: PropTypes.array,
      subtype: PropTypes.bool,
      subcat: PropTypes.array
    })
  ),
  isMobile: PropTypes.bool
};

SelectionPage.defaultProps = {
  categories: {}
};

export default SelectionPage;
